import storage from "redux-persist/lib/storage";
// import sessionStorage from "redux-persist/lib/storage/session";

// ROOT PERSIST CONFIG
export const persistConfig = {
  key: "root",
  storage: storage,
  blacklist: [
    "authTabParams",
    "createPoll",
    "feeds",
    "authentication",
    "comments",
    "chat",
  ],
};

// AUTH PERSIST CONFIG
export const authPersistConfig = {
  key: "authentication",
  storage: storage,
  blacklist: ["registerError"],
};

// CREATE POLL PERSIST CONFIG
export const createPollPersistConfig = {
  key: "createPoll",
  storage: storage,
  blacklist: ["step1TabParams", "step2TabParams"],
};

// FEED PERSIST CONFIG
export const feedPersistConfig = {
  key: "feed",
  storage: storage,
  blacklist: [
    "userPolls",
    "userPollsLoading",
    "userFollowers",
    "userFollowersLoading",
  ],
};

// COMMENTS PERSIST CONFIG
export const commentsPersistConfig = {
  key: "comments",
  storage: storage,
  blacklist: ["comments"],
};

// CHAT PERSIST CONFIG
export const chatPersistConfig = {
  key: "chat",
  storage: storage,
  blacklist: ["commonPolls", "commonPollsLoading"],
};
